import {Box} from "@mui/joy";

export type LogoProps = {
    /** Width in pixels, the height follows the artwork */
    width?: number
}

/**
 * The Score Vision mark and lockup.
 *
 * Both are drawn on transparency and read against the dark surfaces the apps use, so they are shown
 * as they are — no plate behind them, and no recolouring.
 */
export const Logo = ({width = 100}: LogoProps) =>
    <Box component={"img"} width={width} src={require("../assets/logo.png")} alt={"Score Vision"}
         sx={{objectFit: "contain"}}/>

/** The mark next to the word, which is how the app signs itself */
const FullLogo = ({width = 200}: LogoProps) =>
    <Box component={"img"} width={width} src={require("../assets/full_logo.png")} alt={"Score Vision"}
         sx={{objectFit: "contain"}}/>

/** The same lockup, at the size the mobile bar has room for */
export const FullLogoSmall = () => <FullLogo width={80}/>

export default FullLogo
